import { useObservable } from '@logz-pkg/observable';
import { ConfirmModal } from '@logz-ui/styleguide';
import { ComponentProps } from 'react';
import { appConfirmModalObservable } from 'services/ui-services/dialog.service';

const noop = () => {};
export const useAppConfirmModal = () => {
  return {
    ...useObservable(appConfirmModalObservable),
    setProps: (props: ComponentProps<typeof ConfirmModal>) => {
      appConfirmModalObservable.set({
        ...appConfirmModalObservable.get(),
        open: props.isOpen ?? false,
        onConfirm: props.onConfirm ?? noop,
        onCancel: props.onClose ?? noop,
        ...props,
      });
    },
  };
};
